export const ASSISTIMO_ROUTE = "/assistimo";

export const getAssistimoChatRoute = (chatSessionID: string) => `${ASSISTIMO_ROUTE}/${chatSessionID}`;

export const isAssistimoRoute = (pathname: string) => {
  const path = pathname.toLowerCase();
  return path === ASSISTIMO_ROUTE || path.startsWith(`${ASSISTIMO_ROUTE}/`);
};
